import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';

import { Layout, ButtonLink, SectionLabel, SucursalLabel } from '../styled';
import theme from '../styled/theme';
import SectionHead from '../ItemForm/SectionHead';
import CustomerInfo from '../ItemForm/CustomerInfo';
import PriceTag from '../PriceTag';
import Checkbox from '../ItemForm/Checkbox';
import { seaweed } from '../styled/variables';

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1100px;
`;

const Section = styled.section`
  margin-bottom: 1.1rem;
`;

const SectionBody = styled.div`
  background: #f0f0d5;
  border-radius: 2rem;
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.6rem;
  padding: 0 20px;

  @media (max-width: 767px) {
    padding: 12px;
  }
`;

const Card = styled.div`
  padding: 0.6rem 0.65rem;
  position: relative;
  width: 100%;
`;

const ItemName = styled.div`
  font-size: 3rem;
  font-family: 'Oneer';
  text-align: left;
`;

const Price = styled.div`
  font-weight: 900;
  margin-top: 0.2rem;
`;

const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.35rem;
`;

const NigiriGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 0.75rem;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

const NigiriCard = styled(Card)`
  padding: 0;
  display: grid;
  grid-template-columns: 1.4fr auto auto;
  align-items: center;
  gap: 0.85rem;

  @media (max-width: 767px) {
    grid-template-columns: 1.2fr auto auto;
    ${ItemName} {
      font-size: 2.2rem;
    }
  }
`;

const NigiriNote = styled.div`
  font-weight: 800;
  font-size: 1rem;
  text-transform: uppercase;
  text-align: center;
`;

const NigiriHelper = styled.div`
  font-weight: 700;
  font-size: 0.95rem;
  text-align: center;
  margin: 0.35rem 0 0.85rem;
  text-transform: uppercase;
`;

const NigiriTabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin: 0.5rem 0 0.75rem;
`;

const NigiriTab = styled.button`
  border: 2px solid #1e1c1a;
  background: ${props => (props.active ? '#1e1c1a' : '#fffef7')};
  color: ${props => (props.active ? '#fff' : '#1e1c1a')};
  padding: 0.4rem 0.75rem;
  border-radius: 6px;
  font-weight: 800;
  cursor: pointer;
  text-transform: uppercase;
`;

const NigiriActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
`;

const NigiriActionButton = styled.button`
  border: 2px solid #1e1c1a;
  background: #fffef7;
  color: #1e1c1a;
  padding: 0.35rem 0.65rem;
  border-radius: 6px;
  font-weight: 800;
  cursor: pointer;
  text-transform: uppercase;
`;

const BastonImage = styled.img`
  height: 130px;
  width: auto;
  object-fit: contain;
  display: block;
`;

const ComboRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.6rem;

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const Combo = styled.div`
  border: 2px solid #1e1c1a;
  border-radius: 8px;
  padding: 0.65rem 0.75rem;
  background: #fffef7;
  font-weight: 800;
`;

const StyledCheckbox = styled(Checkbox)`
  margin-top: 0.5rem;

  label {
    font-weight: 800;
    text-transform: uppercase;
    gap: 0.45rem;
  }
`;

const Header = styled.div`
  position: relative;

  ${SectionLabel} {
    transform: rotate(-10deg);
    left: -2rem;
    min-width: 225px;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    top: 1rem;
  }

  ${SucursalLabel} {
    transform: rotate(-10deg);
    right: -2rem;
    min-width: 225px;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    top: -20rem;
    width: auto;
    z-index: 100;
  }
`;

const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

const ThreeColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr;
  gap: 0.5rem;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

const QuantityInput = styled.input`
  margin-top: 0.35rem;
  width: 100px;
  padding: 0.35rem 0.4rem;
  border: 2px solid #1e1c1a;
  border-radius: 6px;
  font-weight: 700;
  @media (max-width: 767px) {
    width: 80px;
    padding: 0.3rem 0.35rem;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  justify-content: center;
  margin-top: 1.25rem;
`;

const FooterButton = styled(ButtonLink)`
  background: ${props => props.bg || theme.colors.primary};
  color: #fff;
  border-radius: 8px;
  font-size: 1rem;
  padding: 0.75rem 1.2rem;
  text-transform: uppercase;
  font-family: 'Oneer';
  letter-spacing: 0.04em;
`;

const StickyActions = styled.div`
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  gap: 0.75rem;
  z-index: 200;

  @media (max-width: 767px) {
    padding: 0.6rem 0.5rem;

    a {
      font-size: 0.7rem;
    }
  }
`;

const FeaturedCard = styled(Card)`
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
`;

const FeaturedContent = styled.div`
  position: relative;
  z-index: 10;
  text-align: center;
`;

const FeaturedNote = styled.div`
  font-family: Arial, sans-serif;
  font-size: 16px;
  margin-top: 0.35rem;
`;

const tartarCombos = [
  { name: 'ATUN', price: 825, quantity: 1 },
  { name: 'SALMON', price: 825, quantity: 1 },
  { name: 'KING CraB', price: 695, quantity: 1 },
  { name: 'DOrADO AL LIMoN', price: 800, quantity: 1 },
  { name: 'CAMArON', price: 895, quantity: 1 },
  { name: 'CAMArON PANKO', price: 895, quantity: 1 },
  { name: 'SUrIMI', price: 825, quantity: 1 },
  { name: 'POLLO', price: 675, quantity: 1 },
];

const sashimi = [
  { name: 'ATUN', price: 795, quantity: 1 },
  { name: 'SALMON', price: 825, quantity: 1 },
  { name: 'DOrADO AL LIMoN', price: 725, quantity: 1 },
  { name: 'CAMARON', price: 850, quantity: 1 },
];

const nigiri = [
  { name: 'Camaron', note: 'la pieza', price: 105, quantity: 1 },
  { name: 'Salmon', note: 'la pieza', price: 105, quantity: 1 },
  { name: 'Dorado aL Limon', note: 'orden 5 piezas', price: 105, quantity: 1 },
  { name: 'Surimi', note: 'orden 5 piezas', price: 105, quantity: 1 },
  { name: 'Atun', note: 'la pieza', price: 105, quantity: 1 },
];

const bastones = [
  { name: 'Pollo', price: 375, quantity: 1 },
  { name: 'CamarOn panko', price: 375, quantity: 1 },
  { name: 'Surimi', price: 375, quantity: 1 },
];

const bastonImages = {
  Pollo: 'baston pollo.png',
  'CamarOn panko': 'baston panko.png',
  Surimi: 'baston surimi.png',
};

const estrella = [
  { name: 'La Estrella Madura', price: 895, quantity: 1 },
  { name: 'La Copa Al Limon', price: 695, quantity: 1 },
  { name: 'El Fresco Kingcrab', price: 395, quantity: 1 },
  { name: 'Los 5 Verdes', price: 675, quantity: 1 },
  { name: 'La Canastica de Crunchy', price: 705, quantity: 1 },
];

const sushicake = [
  { name: 'Porción', price: 595, quantity: 1 },
];

const buildQuantityMap = list =>
  list.reduce((acc, item) => {
    acc[item.name] = item.quantity || 1;
    return acc;
  }, {});

const buildSelectionMap = list =>
  list.reduce((acc, item) => {
    acc[item.name] = false;
    return acc;
  }, {});

const branchNames = {
  BAMBAN_NACO: 'BAMBAN NACO',
  BAMBAN_BELLA_VISTA: 'BAMBAN BELLA VISTA',
};

const categoryLabels = {
  tartar: 'Tartar',
  sashimi: 'Sashimi',
  nigiri: 'Niguiri',
  bastones: 'Bastones empanizados',
  estrella: 'La Estrella Madura',
  sushicake: 'Sushicake',
};

const MENU_TWO_STORAGE_KEY = 'menuTwoSelections';
const MENU_TWO_CUSTOMER_KEY = 'menuTwoCustomer';
const NIGIRI_BUNDLE_SIZE = 6;
const NIGIRI_BUNDLE_PRICE = 540;
const NIGIRI_UNIT_PRICE = 105;

const quantityDefaults = {
  tartar: buildQuantityMap(tartarCombos),
  sashimi: buildQuantityMap(sashimi),
  nigiri: buildQuantityMap(nigiri),
  bastones: buildQuantityMap(bastones),
  estrella: buildQuantityMap(estrella),
  sushicake: buildQuantityMap(sushicake),
};

const selectionDefaults = {
  tartar: buildSelectionMap(tartarCombos),
  sashimi: buildSelectionMap(sashimi),
  nigiri: buildSelectionMap(nigiri),
  bastones: buildSelectionMap(bastones),
  estrella: buildSelectionMap(estrella),
  sushicake: buildSelectionMap(sushicake),
};

const mergeWithDefaults = (defaults, saved = {}) =>
  Object.keys(defaults).reduce((acc, category) => {
    acc[category] = { ...defaults[category], ...(saved[category] || {}) };
    return acc;
  }, {});

const createNigiriOrder = () => ({
  id: `${Date.now()}-${Math.random()}`,
  selected: { ...selectionDefaults.nigiri },
  quantities: { ...quantityDefaults.nigiri },
});

const normalizeNigiriOrders = savedOrders => {
  if (!Array.isArray(savedOrders) || !savedOrders.length) {
    return [createNigiriOrder()];
  }

  return savedOrders.map(order => ({
    id: order.id || `${Date.now()}-${Math.random()}`,
    selected: {
      ...selectionDefaults.nigiri,
      ...(order.selected || {}),
    },
    quantities: {
      ...quantityDefaults.nigiri,
      ...(order.quantities || {}),
    },
  }));
};

const getInitialMenuTwoState = () => {
  if (typeof localStorage === 'undefined') {
    return {
      quantities: mergeWithDefaults(quantityDefaults),
      selected: mergeWithDefaults(selectionDefaults),
      nigiriOrders: [createNigiriOrder()],
      customer: { name: '', quantity: 1 },
    };
  }

  let storedState;
  try {
    const raw = localStorage.getItem(MENU_TWO_STORAGE_KEY);
    if (raw) {
      storedState = JSON.parse(raw);
    }
  } catch (err) {
    storedState = null;
  }

  return {
    quantities: mergeWithDefaults(quantityDefaults, storedState?.quantities),
    selected: mergeWithDefaults(selectionDefaults, storedState?.selected),
    nigiriOrders: normalizeNigiriOrders(storedState?.nigiriOrders),
    customer: { name: '', quantity: 1 },
  };
};

const MenuTwo = props => {
  const initialState = getInitialMenuTwoState();
  const [quantities, setQuantities] = useState(() => initialState.quantities);
  const [selected, setSelected] = useState(() => initialState.selected);
  const [nigiriOrders, setNigiriOrders] = useState(() => initialState.nigiriOrders);
  const [customer, setCustomer] = useState(() => initialState.customer);
  const [activeNigiriOrder, setActiveNigiriOrder] = useState(0);

  const [
    tartarAtun,
    tartarSalmon,
    tartarKingCrab,
    tartarDorado,
    tartarCamaron,
    tartarCamaronPanko,
    tartarSurimi,
    tartarPollo,
  ] = tartarCombos;

  const [sashimiAtun, sashimiSalmon, sashimiDorado, sashimiCamaron] = sashimi;
  const [estrellaMadura, copaAlLimon, frescoKingcrab, cincoVerdes, canasticaCrunchy] = estrella;
  const [sushicakePortion] = sushicake;

  useEffect(() => {
    localStorage.setItem(
      MENU_TWO_STORAGE_KEY,
      JSON.stringify({ quantities, selected, nigiriOrders })
    );
  }, [quantities, selected, nigiriOrders]);

  const resetMenuTwoUI = () => {
    setQuantities(mergeWithDefaults(quantityDefaults));
    setSelected(mergeWithDefaults(selectionDefaults));
    setNigiriOrders([createNigiriOrder()]);
    setActiveNigiriOrder(0);
    setCustomer({ name: '', quantity: 1 });
    localStorage.removeItem(MENU_TWO_STORAGE_KEY);
  };

  useEffect(() => {
    if (activeNigiriOrder >= nigiriOrders.length) {
      setActiveNigiriOrder(nigiriOrders.length - 1);
    }
  }, [activeNigiriOrder, nigiriOrders.length]);

  const activeNigiri = nigiriOrders[activeNigiriOrder] || nigiriOrders[0];

  const clampNigiriQuantity = (order, name, proposedValue) => {
    const totalOther = Object.keys(order.selected).reduce((acc, itemName) => {
      if (itemName === name || !order.selected[itemName]) return acc;
      return acc + (parseFloat(order.quantities[itemName]) || 0);
    }, 0);
    const allowed = Math.max(0, NIGIRI_BUNDLE_SIZE - totalOther);
    return Math.min(proposedValue, allowed);
  };

  const handleQuantityChange = (category, name) => event => {
    const value = parseFloat(event.target.value);
    const safeValue = Number.isFinite(value) && value > 0 ? value : 1;

    setQuantities(prev => ({
      ...prev,
      [category]: { ...prev[category], [name]: safeValue },
    }));
  };

  const handleSelectChange = (category, name) => event => {
    const checked = event.target.checked;

    setSelected(prev => ({
      ...prev,
      [category]: { ...prev[category], [name]: checked },
    }));
  };

  const handleCustomerChange = ({ target }) => {
    const value = target.type === 'number' ? parseFloat(target.value) : target.value;
    setCustomer(prev => ({
      ...prev,
      [target.name]: target.type === 'number' ? (Number.isFinite(value) && value > 0 ? value : prev.quantity) : value,
    }));
  };

  const setCustomerQuantity = quantity => {
    setCustomer(prev => ({ ...prev, quantity }));
  };

  const handleNigiriQuantityChange = (orderIndex, name) => event => {
    const rawValue = parseFloat(event.target.value);
    const baseValue = Number.isFinite(rawValue) && rawValue > 0 ? rawValue : 1;
    setNigiriOrders(prev =>
      prev.map((order, idx) => {
        if (idx !== orderIndex) return order;
        const clamped = clampNigiriQuantity(order, name, baseValue);
        return {
          ...order,
          quantities: { ...order.quantities, [name]: clamped },
        };
      })
    );
  };

  const handleNigiriSelectChange = (orderIndex, name) => event => {
    const checked = event.target.checked;
    setNigiriOrders(prev =>
      prev.map((order, idx) => {
        if (idx !== orderIndex) return order;
        const desired = checked ? Math.max(1, parseFloat(order.quantities[name]) || 1) : order.quantities[name];
        const clamped = checked ? clampNigiriQuantity(order, name, desired) : desired;
        return {
          ...order,
          selected: { ...order.selected, [name]: checked },
          quantities: checked ? { ...order.quantities, [name]: clamped } : order.quantities,
        };
      })
    );
  };

  const addNigiriOrder = () => {
    setNigiriOrders(prev => [...prev, createNigiriOrder()]);
    setActiveNigiriOrder(prev => prev + 1);
  };

  const removeNigiriOrder = orderIndex => {
    setNigiriOrders(prev => {
      if (prev.length <= 1) return prev;
      return prev.filter((_, idx) => idx !== orderIndex);
    });
    setActiveNigiriOrder(prev => {
      if (prev === orderIndex) return Math.max(0, prev - 1);
      if (prev > orderIndex) return prev - 1;
      return prev;
    });
  };

  const toggleSelection = (category, name) =>
    handleSelectChange(category, name)({
      target: { checked: !selected[category][name] },
    });

  const getPrice = (category, item) => item.price || 0;

  const buildMenuItem = (category, item, overrides = {}) => {
    const customerName = (customer?.name || '').trim();
    const quantity = overrides.quantity ?? quantities[category][item.name];
    const isChecked = overrides.isChecked ?? selected[category][item.name];

    if (!isChecked || !quantity) return null;

    const price = overrides.price ?? getPrice(category, item);
    if (!price) return null;
    return {
      name: customerName || item.name,
      quantity,
      wrapping: {
        category: category === 'estrella' ? item.name : categoryLabels[category],
        categoryKey: category,
        itemName: item.name,
        title: item.note || item.name,
        price,
      },
      proteins: [],
      sauces: [],
      complements: [],
      toppings: [],
      bowlOptions: [],
      totalPrice: parseFloat(quantity) * price,
      note: item.note,
      menu: 'menutwo',
    };
  };

  const persistSelections = () => {
    const menuItems = {
      tartar: tartarCombos,
      sashimi,
      bastones,
      estrella,
      sushicake,
    };

    const payloads = [];

    Object.keys(menuItems).forEach(category => {
      menuItems[category].forEach(item => {
        const payload = buildMenuItem(category, item);
        if (payload) {
          payloads.push(payload);
        }
      });
    });

    // Nigiri: per-order cap and pricing.
    nigiriOrders.forEach((order, orderIndex) => {
      const nigiriSelections = Object.keys(order.selected).filter(name => order.selected[name]);
      const nigiriItems = nigiriSelections
        .map(name => ({
          item: nigiri.find(n => n.name === name),
          quantity: parseFloat(order.quantities[name]) || 0,
        }))
        .filter(entry => entry.item && entry.quantity > 0);

      let remaining = NIGIRI_BUNDLE_SIZE;
      const cappedNigiri = nigiriItems
        .map(entry => {
          if (remaining <= 0) return { ...entry, quantity: 0 };
          const allowed = Math.min(entry.quantity, remaining);
          remaining -= allowed;
          return { ...entry, quantity: allowed };
        })
        .filter(entry => entry.quantity > 0);

      const totalNigiriPieces = cappedNigiri.reduce((acc, entry) => acc + entry.quantity, 0);
      if (totalNigiriPieces <= 0) return;

      const bundles = Math.floor(totalNigiriPieces / NIGIRI_BUNDLE_SIZE);
      const remainder = totalNigiriPieces % NIGIRI_BUNDLE_SIZE;
      const nigiriTotalPrice =
        bundles > 0 && remainder === 0
          ? bundles * NIGIRI_BUNDLE_PRICE
          : bundles * NIGIRI_BUNDLE_PRICE + remainder * NIGIRI_UNIT_PRICE;
      const nigiriPricePerPiece = nigiriTotalPrice / totalNigiriPieces;
      const breakdown = cappedNigiri.map(entry => `${entry.item.name} x${entry.quantity}`).join(', ');

      const combinedNigiriItem = buildMenuItem(
        'nigiri',
        { name: `Niguiri Orden ${orderIndex + 1}`, note: breakdown },
        {
          quantity: totalNigiriPieces,
          price: nigiriPricePerPiece,
          isChecked: true,
        }
      );

      if (combinedNigiriItem) {
        payloads.push(combinedNigiriItem);
      }
    });

    if (props.context?.addItem) {
      payloads.forEach(item => props.context.addItem(item));
    } else if (props.context?.setMenuItemsForMenu) {
      props.context.setMenuItemsForMenu('menutwo', payloads);
    }
  };

  const renderEstrellaSection = () => (
    <Section className="section-plates">
      <SectionBody>
        <Card
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1.3fr',
            gap: '0.75rem',
            alignItems: 'start',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img
              src={`${process.env.PUBLIC_URL}/img/la_estrella_madura.png`}
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
              alt={estrellaMadura.name}
              onClick={() => toggleSelection('estrella', estrellaMadura.name)}
            />
          </div>
          <div>
            <div>
              <SectionHead
                bgColor="white"
                fontWeight="400"
                textColor="black"
                textTransform="initial"
                textAlign="left"
                margin="0"
                titleSize="30px"
                descriptionSize="0.7rem"
                descriptionSizeMobile="0.6rem"
                descriptionOutside
                descriptionColor="black"
                descriptionAlign="left"
                description="Mezcla en Salsa Anguila de Pollo Tempura y Plátano Maduro con topping de Bacon Tostado acompañado de cinco tortas de Arroz y Alga con rebanadas de Aguacate."
              >
                La EsTRELLA MaDUra
              </SectionHead>
            </div>
            <PriceRow style={{ marginTop: '0.5rem' }}>
              <StyledCheckbox
                type="checkbox"
                id={`estrella-${estrellaMadura.name}`}
                checked={selected.estrella[estrellaMadura.name]}
                handleChange={handleSelectChange('estrella', estrellaMadura.name)}
              />
              <PriceTag
                transform="none"
                margin="0 10px"
                position="relative"
                textColor="black"
                fontWeight="400"
                price={estrellaMadura.price}
              />
            </PriceRow>
            <QuantityInput
              name={`${estrellaMadura.name}-qty`}
              type="number"
              value={quantities.estrella[estrellaMadura.name]}
              onChange={handleQuantityChange('estrella', estrellaMadura.name)}
              required
            />
          </div>
        </Card>
      </SectionBody>
    </Section>
  );

  const renderLimonyKingCrab = () => (
    <Section className="section-plates">

      <SectionBody>
        <Card
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1.3fr',
            gap: '0.75rem',
            alignItems: 'start',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img
              src={`${process.env.PUBLIC_URL}/img/la_copa_al_limon.png`}
              alt={copaAlLimon.name}
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
              onClick={() => toggleSelection('estrella', copaAlLimon.name)}
            />
          </div>
          <div>
            <div>
              <SectionHead
                bgColor="white"
                fontWeight="400"
                textColor="black"
                textTransform="initial"
                textAlign="left"
                margin="0"
                titleSize="45px"
                descriptionSize="0.7rem"
                descriptionSizeMobile="0.6rem"
                descriptionOutside
                descriptionColor="black"
                descriptionAlign="left"
                description="Relleno en capas de Crunchy, Creamcheese, Aguacate, Salsa Cilantro Mayo, Dorado al limón y Pico de Gallo de Ajíes Morrones."
              >
                La Copa Al LiMoN
              </SectionHead>
            </div>
            <PriceRow style={{ marginTop: '0.5rem' }}>
              <StyledCheckbox
                type="checkbox"
                id={`estrella-${copaAlLimon.name}`}
                checked={selected.estrella[copaAlLimon.name]}
                handleChange={handleSelectChange('estrella', copaAlLimon.name)}
              />
              <PriceTag
                transform="none"
                margin="0 10px"
                position="relative"
                textColor="black"
                fontWeight="400"
                price={copaAlLimon.price}
              />
            </PriceRow>
            <QuantityInput
              name={`${copaAlLimon.name}-qty`}
              type="number"
              value={quantities.estrella[copaAlLimon.name]}
              onChange={handleQuantityChange('estrella', copaAlLimon.name)}
              required
            />
          </div>
        </Card>
      </SectionBody>

      <SectionBody>
        <Card
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1.3fr',
            gap: '0.75rem',
            alignItems: 'start',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img
              src={`${process.env.PUBLIC_URL}/img/el_refresco_kingcrab.png`}
              alt={frescoKingcrab.name}
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
              onClick={() => toggleSelection('estrella', frescoKingcrab.name)}
            />
          </div>
          <div>
            <div>
              <SectionHead
                bgColor="white"
                fontWeight="400"
                textColor="black"
                textTransform="initial"
                textAlign="left"
                margin="0"
                titleSize="45px"
                descriptionSize="0.7rem"
                descriptionSizeMobile="0.6rem"
                descriptionOutside
                descriptionColor="black"
                descriptionAlign="left"
                description="Rollo envuelto en Pepino y algas con Kingcrab, Creamcheese, Bacon y Aguacate, con topping de Tabiko y Salsa chimichurri; Acompañado de una Kanikama Salad."
              >
                El FRESCo KiNGCrAb
              </SectionHead>
            </div>
            <PriceRow style={{ marginTop: '0.5rem' }}>
              <StyledCheckbox
                type="checkbox"
                id={`estrella-${frescoKingcrab.name}`}
                checked={selected.estrella[frescoKingcrab.name]}
                handleChange={handleSelectChange('estrella', frescoKingcrab.name)}
              />
              <PriceTag
                transform="none"
                margin="0 10px"
                position="relative"
                textColor="black"
                fontWeight="400"
                price={frescoKingcrab.price}
              />
            </PriceRow>
            <QuantityInput
              name={`${frescoKingcrab.name}-qty`}
              type="number"
              value={quantities.estrella[frescoKingcrab.name]}
              onChange={handleQuantityChange('estrella', frescoKingcrab.name)}
              required
            />
          </div>
        </Card>
      </SectionBody>
    </Section>
  );

  const renderCanasticayVerdes = () => (
    <Section className="section-plates">

      <SectionBody>
        <Card
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1.3fr',
            gap: '0.75rem',
            alignItems: 'start',
            paddingBottom: '60px'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img
              src={`${process.env.PUBLIC_URL}/img/lo_5_verdes.png`}
              alt={cincoVerdes.name}
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
              onClick={() => toggleSelection('estrella', cincoVerdes.name)}
            />
          </div>
          <div>
            <div>
              <SectionHead
                bgColor="white"
                fontWeight="400"
                textColor="black"
                textTransform="initial"
                textAlign="left"
                margin="0"
                titleSize="45px"
                descriptionSize="0.7rem"
                descriptionSizeMobile="0.6rem"
                descriptionOutside
                descriptionColor="black"
                descriptionAlign="left"
                description="Edamame, Guisantes Revestidos en Wassabi, Wakame Salad, Queso Brie con Cilantrico y Niguiri de Aguacate Empanizado."
              >
                Los 5 VERdEs
              </SectionHead>
            </div>
            <PriceRow style={{ marginTop: '0.5rem' }}>
              <StyledCheckbox
                type="checkbox"
                id={`estrella-${cincoVerdes.name}`}
                checked={selected.estrella[cincoVerdes.name]}
                handleChange={handleSelectChange('estrella', cincoVerdes.name)}
              />
              <PriceTag
                transform="none"
                margin="0 10px"
                position="relative"
                textColor="black"
                fontWeight="400"
                price={cincoVerdes.price}
              />
            </PriceRow>
            <QuantityInput
              name={`${cincoVerdes.name}-qty`}
              type="number"
              value={quantities.estrella[cincoVerdes.name]}
              onChange={handleQuantityChange('estrella', cincoVerdes.name)}
              required
            />
          </div>
        </Card>
      </SectionBody>

      <Section>
        <SectionBody>
          <Card
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1.3fr',
              gap: '0.75rem',
              alignItems: 'start',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
              <img
                src={`${process.env.PUBLIC_URL}/img/la_canastica_de_crunchy.png`}
                alt={canasticaCrunchy.name}
                style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
                onClick={() => toggleSelection('estrella', canasticaCrunchy.name)}
              />
            </div>
            <div>
              <div>
                <SectionHead
                  bgColor="white"
                  fontWeight="400"
                  textColor="black"
                  textTransform="initial"
                  textAlign="left"
                  margin="0"
                  titleSize="45px"
                  descriptionSize="0.7rem"
                  descriptionSizeMobile="0.6rem"
                  descriptionOutside
                  descriptionColor="black"
                  descriptionAlign="left"
                  description="Tortilla de Crunchy desbordante de todas las Proteínas del menú Empanizadas en Crunchy rellena de una cremosa mezcla de Creamcheese, Aguacate, Pico de Gallo de Ajies Morrones, Puerro y Cilantrico con SpicyMayo."
                >
                  La CANASTICa DE CrUNchY
                </SectionHead>
              </div>
              <PriceRow style={{ marginTop: '0.5rem' }}>
                <StyledCheckbox
                  type="checkbox"
                  id={`estrella-${canasticaCrunchy.name}`}
                  checked={selected.estrella[canasticaCrunchy.name]}
                  handleChange={handleSelectChange('estrella', canasticaCrunchy.name)}
                />
                <PriceTag
                  transform="none"
                  margin="0 10px"
                  position="relative"
                  textColor="black"
                  fontWeight="400"
                  price={canasticaCrunchy.price}
                />
              </PriceRow>
              <QuantityInput
                name={`${canasticaCrunchy.name}-qty`}
                type="number"
                value={quantities.estrella[canasticaCrunchy.name]}
                onChange={handleQuantityChange('estrella', canasticaCrunchy.name)}
                required
              />
            </div>
          </Card>
        </SectionBody>
      </Section>
    </Section>
  );

  const renderSushicakePortion = () => (
    <Section className="section-plates">
      <SectionBody>
        <Card
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1.3fr',
            gap: '0.75rem',
            alignItems: 'start',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <img
              src={`${process.env.PUBLIC_URL}/img/sushicake-porcion.png`}
              alt="Sushicake Porción"
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
              onClick={() => toggleSelection('sushicake', sushicakePortion.name)}
            />
          </div>
          <div>
            <SectionHead
              bgColor="white"
              fontWeight="400"
              textColor="black"
              textTransform="initial"
              textAlign="left"
              margin="0"
              titleSize="45px"
              descriptionSize="0.85rem"
              descriptionSizeMobile="0.7rem"
              descriptionOutside
              descriptionColor="black"
              descriptionAlign="left"
              description="CAPAS DE ARROZ DE SUSHI RELLENAS DE TODAS LAS PROTEÍNAS, COMPLEMENTOS Y SALSAS DE BAMBÁN SUSHI, DECORADO CON CREAMCHEESE Y CRUNCHY COMO SUSPIRO."
            >
              Sushicake Porcion
            </SectionHead>
            <PriceRow style={{ marginTop: '0.5rem' }}>
              <StyledCheckbox
                type="checkbox"
                id={`sushicake-${sushicakePortion.name}`}
                checked={selected.sushicake[sushicakePortion.name]}
                handleChange={handleSelectChange('sushicake', sushicakePortion.name)}
              />
              <PriceTag
                transform="none"
                margin="0 10px"
                position="relative"
                textColor="black"
                fontWeight="400"
                price={sushicakePortion.price}
              />
            </PriceRow>
            <QuantityInput
              name={`${sushicakePortion.name}-qty`}
              type="number"
              value={quantities.sushicake[sushicakePortion.name]}
              onChange={handleQuantityChange('sushicake', sushicakePortion.name)}
              required
            />
          </div>
        </Card>
      </SectionBody>
    </Section>
  );

  return (
    <Fragment>
      <Header>
        <MediaQuery minDeviceWidth={768}>
          {props.branch && (
            <SucursalLabel background={seaweed} color="white">
              SUCURSAL: {branchNames[props.branch] || props.branch}
            </SucursalLabel>
          )}
          <SectionLabel background={seaweed} color="white" style={{ top: "-70px" }}>
            IDEAL PaRA CoMPaRTIR
          </SectionLabel>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={767}>
          {props.branch && (
            <SucursalLabel background={seaweed} color="white">
              SUCURSAL: {branchNames[props.branch] || props.branch}
            </SucursalLabel>
          )}
        </MediaQuery>
      </Header>
      <Wrapper>
        <SectionBody>
          <CustomerInfo
            name={customer.name}
            quantity={parseFloat(customer.quantity)}
            handleChange={handleCustomerChange}
            setQuantity={setCustomerQuantity}
            hideQuantity
            showPrimaryLink
            onCheckoutClick={() => {
              persistSelections();
              resetMenuTwoUI();
            }}
          />
        </SectionBody>
        <Section>
          <SectionHead
            bgColor="white"
            fontWeight="400"
            textColor="black"
            description="elige tu combinación favorita"
            price="675 - 895"
          >
            Tartar
          </SectionHead>
          <SectionBody>
            <ThreeColumnGrid>
              <div className='flex customBorderRight'>
                <FeaturedCard key={tartarAtun.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/atun.png`}
                      width="120"
                      alt={tartarAtun.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarAtun.name)}
                    />
                    <img
                      style={{ position: 'absolute', top: -30, left: -30, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="80"
                      alt={tartarAtun.name}
                    />
                    <FeaturedNote>+Ajonjolí +Soya</FeaturedNote>
                    <QuantityInput
                      name={`${tartarAtun.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarAtun.name]}
                      onChange={handleQuantityChange('tartar', tartarAtun.name)}
                      required
                    />
                  </FeaturedContent>
                  <PriceRow style={{ position: 'absolute', top: -5, right: 10, zIndex: 20 }}>
                    <StyledCheckbox
                      type="checkbox"
                      id={`tartar-${tartarAtun.name}`}
                      checked={selected.tartar[tartarAtun.name]}
                      handleChange={handleSelectChange('tartar', tartarAtun.name)}
                    />
                    <PriceTag
                      transform="none"
                      margin="0"
                      position="relative"
                      textColor="black"
                      fontWeight="400"
                      price={tartarAtun.price}
                      fontWeight="400"
                      textColor="black"
                      clickable
                      onClick={() => toggleSelection('tartar', tartarAtun.name)}
                    />
                  </PriceRow>
                </FeaturedCard>
                <FeaturedCard key={tartarSalmon.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/salmon.png`}
                      width="120"
                      alt={tartarSalmon.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarSalmon.name)}
                    />
                    <img
                      style={{ position: 'absolute', top: -80, right: -60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/plate2.png`}
                      width="100"
                      alt={tartarSalmon.name}
                      className="plate2-desktop"
                    />
                    <MediaQuery maxDeviceWidth={767}>
                      <img
                        style={{ position: 'absolute', top: -60, right: -40, zIndex: -1 }}
                        src={`${process.env.PUBLIC_URL}/img/backmenu/plate2.png`}
                        width="70"
                        alt={tartarSalmon.name}
                      />
                    </MediaQuery>
                    <FeaturedNote>&nbsp;</FeaturedNote>
                    <PriceRow style={{ position: 'absolute', bottom: 35, right: 0, zIndex: 20 }}>
                      <StyledCheckbox
                        type="checkbox"
                        id={`tartar-${tartarSalmon.name}`}
                        checked={selected.tartar[tartarSalmon.name]}
                        handleChange={handleSelectChange('tartar', tartarSalmon.name)}
                      />
                      <PriceTag
                        transform="none"
                        margin="0"
                        position="relative"
                        textColor="black"
                        fontWeight="400"
                        price={tartarSalmon.price}
                        clickable
                        onClick={() => toggleSelection('tartar', tartarSalmon.name)}
                      />
                    </PriceRow>
                    <QuantityInput
                      name={`${tartarSalmon.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarSalmon.name]}
                      onChange={handleQuantityChange('tartar', tartarSalmon.name)}
                      required
                    />
                  </FeaturedContent>
                </FeaturedCard>
              </div>
              <div className='flex customBorderRight'>
                <FeaturedCard key={tartarKingCrab.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/kingcrab.png`}
                      width="120"
                      alt={tartarKingCrab.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarKingCrab.name)}
                    />
                    <img
                      style={{ position: 'absolute', top: -40, right: -60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="80"
                      alt={tartarKingCrab.name}
                    />
                    <img
                      style={{ position: 'absolute', top: -10, right: 100, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="80"
                      alt={tartarKingCrab.name}
                    />
                    <img
                      style={{ position: 'absolute', bottom: 20, right: 60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/plate.png`}
                      width="80"
                      alt={tartarKingCrab.name}
                    />
                    <FeaturedNote>&nbsp;</FeaturedNote>
                    <PriceRow style={{ position: 'absolute', top: -50, right: 100, zIndex: 20 }}>
                      <StyledCheckbox
                        type="checkbox"
                        id={`tartar-${tartarKingCrab.name}`}
                        checked={selected.tartar[tartarKingCrab.name]}
                        handleChange={handleSelectChange('tartar', tartarKingCrab.name)}
                      />
                      <PriceTag
                        transform="none"
                        margin="0"
                        position="relative"
                        textColor="black"
                        fontWeight="400"
                        price={tartarKingCrab.price}
                        clickable
                        onClick={() => toggleSelection('tartar', tartarKingCrab.name)}
                      />
                    </PriceRow>
                    <QuantityInput
                      name={`${tartarKingCrab.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarKingCrab.name]}
                      onChange={handleQuantityChange('tartar', tartarKingCrab.name)}
                      required
                    />
                  </FeaturedContent>
                </FeaturedCard>
              </div>
              <div className='flex'>
                <FeaturedCard key={tartarDorado.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/dorado.png`}
                      width="120"
                      alt={tartarDorado.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarDorado.name)}
                    />
                    <img
                      style={{ position: 'absolute', top: 60, right: -60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="80"
                      alt={tartarDorado.name}
                    />
                    <img
                      style={{ position: 'absolute', top: -40, right: 100, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="80"
                      alt={tartarDorado.name}
                    />
                    <img
                      style={{ position: 'absolute', top: -40, right: -60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/plate3.png`}
                      width="80"
                      alt={tartarDorado.name}
                    />
                    <img
                      style={{ position: 'absolute', bottom: 40, right: 90, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/stick.png`}
                      width="80"
                      alt={tartarDorado.name}
                    />
                    <FeaturedNote>&nbsp;</FeaturedNote>
                    <PriceRow style={{ position: 'absolute', bottom: 0, left: 115, zIndex: 20 }}>
                      <StyledCheckbox
                        type="checkbox"
                        id={`tartar-${tartarDorado.name}`}
                        checked={selected.tartar[tartarDorado.name]}
                        handleChange={handleSelectChange('tartar', tartarDorado.name)}
                      />
                      <PriceTag
                        transform="none"
                        margin="0"
                        position="relative"
                        textColor="black"
                        fontWeight="400"
                        price={tartarDorado.price}
                        clickable
                        onClick={() => toggleSelection('tartar', tartarDorado.name)}
                      />
                    </PriceRow>
                    <QuantityInput
                      name={`${tartarDorado.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarDorado.name]}
                      onChange={handleQuantityChange('tartar', tartarDorado.name)}
                      required
                    />
                  </FeaturedContent>
                </FeaturedCard>
              </div>
              <div className='flex customBorderTop customBorderRight customBorderRight'>
                <FeaturedCard key={tartarCamaron.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/camaron.png`}
                      width="120"
                      alt={tartarCamaron.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarCamaron.name)}
                    />
                    <img
                      style={{ position: 'absolute', bottom: 40, left: 80, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="70"
                      alt={tartarCamaron.name}
                    />
                    <img
                      style={{ position: 'absolute', top: 30, left: -30, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/plate4.png`}
                      width="70"
                      alt={tartarCamaron.name}
                    />
                    <FeaturedNote>&nbsp;</FeaturedNote>
                    <QuantityInput
                      name={`${tartarCamaron.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarCamaron.name]}
                      onChange={handleQuantityChange('tartar', tartarCamaron.name)}
                      required
                    />
                  </FeaturedContent>
                  <PriceRow style={{ position: 'absolute', top: -5, right: 90, zIndex: 20 }}>
                    <StyledCheckbox
                      type="checkbox"
                      id={`tartar-${tartarCamaron.name}`}
                      checked={selected.tartar[tartarCamaron.name]}
                      handleChange={handleSelectChange('tartar', tartarCamaron.name)}
                    />
                    <PriceTag
                      transform="none"
                      margin="0"
                      position="relative"
                      textColor="black"
                      fontWeight="400"
                      price={tartarCamaron.price}
                      clickable
                      onClick={() => toggleSelection('tartar', tartarCamaron.name)}
                    />
                  </PriceRow>
                </FeaturedCard>
                <FeaturedCard key={tartarCamaronPanko.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/camaron panko.png`}
                      width="120"
                      alt={tartarCamaronPanko.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarCamaronPanko.name)}
                    />
                    <img
                      style={{ position: 'absolute', top: 35, right: -40, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/plate5.png`}
                      width="70"
                      alt={tartarCamaronPanko.name}
                    />
                    <img
                      style={{ position: 'absolute', top: -35, right: -30, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/plate6.png`}
                      width="70"
                      alt={tartarCamaronPanko.name}
                    />
                    <FeaturedNote>&nbsp;</FeaturedNote>
                    <PriceRow style={{ position: 'absolute', bottom: 35, right: -35, zIndex: 20 }}>
                      <StyledCheckbox
                        type="checkbox"
                        id={`tartar-${tartarCamaronPanko.name}`}
                        checked={selected.tartar[tartarCamaronPanko.name]}
                        handleChange={handleSelectChange('tartar', tartarCamaronPanko.name)}
                      />
                      <PriceTag
                        transform="none"
                        margin="0"
                        position="relative"
                        textColor="black"
                        fontWeight="400"
                        price={tartarCamaronPanko.price}
                        clickable
                        onClick={() => toggleSelection('tartar', tartarCamaronPanko.name)}
                      />
                    </PriceRow>
                    <QuantityInput
                      name={`${tartarCamaronPanko.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarCamaronPanko.name]}
                      onChange={handleQuantityChange('tartar', tartarCamaronPanko.name)}
                      required
                    />
                  </FeaturedContent>
                </FeaturedCard>
              </div>
              <div className='flex customBorderTop customBorderRight'>
                <FeaturedCard key={tartarSurimi.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/surimi.png`}
                      width="120"
                      alt={tartarSurimi.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarSurimi.name)}
                    />
                    <img
                      style={{ position: 'absolute', top: -10, right: 100, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="80"
                      alt={tartarSurimi.name}
                    />
                    <img
                      style={{ position: 'absolute', bottom: 40, right: -60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/plate2.png`}
                      width="100"
                      alt={tartarSurimi.name}
                    />
                    <FeaturedNote>&nbsp;</FeaturedNote>
                    <FeaturedNote style={{ position: 'absolute', top: -40, right: -70, zIndex: -1 }}>+Ajonjolí +La Yu</FeaturedNote>
                    <PriceRow style={{ position: 'absolute', bottom: 30, right: 100, zIndex: 20 }}>
                      <StyledCheckbox
                        type="checkbox"
                        id={`tartar-${tartarSurimi.name}`}
                        checked={selected.tartar[tartarSurimi.name]}
                        handleChange={handleSelectChange('tartar', tartarSurimi.name)}
                      />
                      <PriceTag
                        transform="none"
                        margin="0"
                        position="relative"
                        textColor="black"
                        fontWeight="400"
                        price={tartarSurimi.price}
                        clickable
                        onClick={() => toggleSelection('tartar', tartarSurimi.name)}
                      />
                    </PriceRow>
                    <QuantityInput
                      name={`${tartarSurimi.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarSurimi.name]}
                      onChange={handleQuantityChange('tartar', tartarSurimi.name)}
                      required
                    />
                  </FeaturedContent>
                </FeaturedCard>
              </div>
              <div className='flex customBorderTop'>
                <FeaturedCard key={tartarPollo.name}>
                  <FeaturedContent>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/backmenu/pollo.png`}
                      width="120"
                      alt={tartarPollo.name}
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSelection('tartar', tartarPollo.name)}
                    />
                    <img
                      style={{ position: 'absolute', top: 50, right: 100, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/soup.png`}
                      width="80"
                      alt={tartarPollo.name}
                    />
                    <img
                      style={{ position: 'absolute', bottom: 40, right: -60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/grass.png`}
                      width="100"
                      alt={tartarPollo.name}
                    />
                    <img
                      style={{ position: 'absolute', top: -40, right: -60, zIndex: -1 }}
                      src={`${process.env.PUBLIC_URL}/img/backmenu/tocino.png`}
                      width="90"
                      alt={tartarPollo.name}
                    />
                    <FeaturedNote>&nbsp;</FeaturedNote>
                    <PriceRow style={{ position: 'absolute', top: -50, right: 100, zIndex: 20 }}>
                      <StyledCheckbox
                        type="checkbox"
                        id={`tartar-${tartarPollo.name}`}
                        checked={selected.tartar[tartarPollo.name]}
                        handleChange={handleSelectChange('tartar', tartarPollo.name)}
                      />
                      <PriceTag
                        transform="none"
                        margin="0"
                        position="relative"
                        textColor="black"
                        fontWeight="400"
                        price={tartarPollo.price}
                        clickable
                        onClick={() => toggleSelection('tartar', tartarPollo.name)}
                      />
                    </PriceRow>
                    <QuantityInput
                      name={`${tartarPollo.name}-qty`}
                      type="number"
                      value={quantities.tartar[tartarPollo.name]}
                      onChange={handleQuantityChange('tartar', tartarPollo.name)}
                      required
                    />
                  </FeaturedContent>
                </FeaturedCard>
              </div>
            </ThreeColumnGrid>
          </SectionBody>
        </Section>

        <TwoColumnGrid>
          <div>
            <Section>
              <SectionHead bgColor="white" fontWeight="400" textColor="black" price="725 - 850">
                Sashimi
              </SectionHead>
              <SectionBody className="flex-col" style={{ overflow: 'hidden' }}>
                <FeaturedCard key={sashimiAtun.name} style={{ paddingTop: 0 }}>
                  <FeaturedContent>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center' }}>
                      <img
                        src={`${process.env.PUBLIC_URL}/img/backmenu/sashimi_atun.png`}
                        width="250"
                        alt={sashimiAtun.name}
                        style={{ cursor: 'pointer', maxWidth: '40vw', height: 'auto' }}
                        onClick={() => toggleSelection('sashimi', sashimiAtun.name)}
                      />
                      <div>
                        <PriceRow>
                          <StyledCheckbox
                            type="checkbox"
                            id={`sashimi-${sashimiAtun.name}`}
                            checked={selected.sashimi[sashimiAtun.name]}
                            handleChange={handleSelectChange('sashimi', sashimiAtun.name)}
                          />
                          <PriceTag
                            transform="none"
                            margin="0"
                            position="relative"
                            textColor="black"
                            fontWeight="400"
                            price={sashimiAtun.price}
                            clickable
                            onClick={() => toggleSelection('sashimi', sashimiAtun.name)}
                          />
                        </PriceRow>
                        <QuantityInput
                          name={`${sashimiAtun.name}-qty`}
                          type="number"
                          value={quantities.sashimi[sashimiAtun.name]}
                          onChange={handleQuantityChange('sashimi', sashimiAtun.name)}
                          required
                        />

                      </div>
                    </div>
                  </FeaturedContent>
                </FeaturedCard>

                <FeaturedCard key={sashimiSalmon.name} style={{ paddingTop: 0 }}>
                  <FeaturedContent>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center' }}>

                      <div>
                        <PriceRow>
                          <StyledCheckbox
                            type="checkbox"
                            id={`sashimi-${sashimiSalmon.name}`}
                            checked={selected.sashimi[sashimiSalmon.name]}
                            handleChange={handleSelectChange('sashimi', sashimiSalmon.name)}
                          />
                          <PriceTag
                            transform="none"
                            margin="0"
                            position="relative"
                            textColor="black"
                            fontWeight="400"
                            price={sashimiSalmon.price}
                            clickable
                            onClick={() => toggleSelection('sashimi', sashimiSalmon.name)}
                          />
                        </PriceRow>
                        <QuantityInput
                          name={`${sashimiSalmon.name}-qty`}
                          type="number"
                          value={quantities.sashimi[sashimiSalmon.name]}
                          onChange={handleQuantityChange('sashimi', sashimiSalmon.name)}
                          required
                        />
                      </div>
                      <img
                        src={`${process.env.PUBLIC_URL}/img/backmenu/ssalmon_atun.png`}
                        width="250"
                        alt={sashimiSalmon.name}
                        style={{ cursor: 'pointer', maxWidth: '40vw', height: 'auto' }}
                        onClick={() => toggleSelection('sashimi', sashimiSalmon.name)}
                      />
                    </div>
                  </FeaturedContent>
                </FeaturedCard>

                <FeaturedCard key={sashimiDorado.name} style={{ paddingTop: 0 }}>
                  <FeaturedContent>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center' }}>
                      <img
                        src={`${process.env.PUBLIC_URL}/img/backmenu/sashimi_dorado.png`}
                        width="250"
                        alt={sashimiDorado.name}
                        style={{ cursor: 'pointer', maxWidth: '40vw', height: 'auto' }}
                        onClick={() => toggleSelection('sashimi', sashimiDorado.name)}
                      />
                      <div>
                        <PriceRow>
                          <StyledCheckbox
                            type="checkbox"
                            id={`sashimi-${sashimiDorado.name}`}
                            checked={selected.sashimi[sashimiDorado.name]}
                            handleChange={handleSelectChange('sashimi', sashimiDorado.name)}
                          />
                          <PriceTag
                            transform="none"
                            margin="0"
                            position="relative"
                            textColor="black"
                            fontWeight="400"
                            price={sashimiDorado.price}
                            clickable
                            onClick={() => toggleSelection('sashimi', sashimiDorado.name)}
                          />
                        </PriceRow>
                        <QuantityInput
                          name={`${sashimiDorado.name}-qty`}
                          type="number"
                          value={quantities.sashimi[sashimiDorado.name]}
                          onChange={handleQuantityChange('sashimi', sashimiDorado.name)}
                          required
                        />
                      </div>
                    </div>
                  </FeaturedContent>
                </FeaturedCard>

                <FeaturedCard key={sashimiCamaron.name} style={{ paddingTop: 0 }}>
                  <FeaturedContent>
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center' }}>

                      <div>
                        <PriceRow>
                          <StyledCheckbox
                            type="checkbox"
                            id={`sashimi-${sashimiCamaron.name}`}
                            checked={selected.sashimi[sashimiCamaron.name]}
                            handleChange={handleSelectChange('sashimi', sashimiCamaron.name)}
                          />
                          <PriceTag
                            transform="none"
                            margin="0"
                            position="relative"
                            textColor="black"
                            fontWeight="400"
                            price={sashimiCamaron.price}
                            clickable
                            onClick={() => toggleSelection('sashimi', sashimiCamaron.name)}
                          />
                        </PriceRow>
                        <QuantityInput
                          name={`${sashimiCamaron.name}-qty`}
                          type="number"
                          value={quantities.sashimi[sashimiCamaron.name]}
                          onChange={handleQuantityChange('sashimi', sashimiCamaron.name)}
                          required
                        />
                      </div>
                      <div style={{ position: 'relative' }}>
                        <img
                          src={`${process.env.PUBLIC_URL}/img/backmenu/sashimi_camaron.png`}
                          width="250"
                          alt={sashimiCamaron.name}
                          style={{ cursor: 'pointer', maxWidth: '40vw', height: 'auto' }}
                          onClick={() => toggleSelection('sashimi', sashimiCamaron.name)}
                        />
                      </div>
                    </div>
                  </FeaturedContent>
                </FeaturedCard>
              </SectionBody>
            </Section>

            <MediaQuery minDeviceWidth={768}>
              <Fragment>
                {renderEstrellaSection()}
                {renderSushicakePortion()}
              </Fragment>
            </MediaQuery>


          </div>


          <div>
            <Section>
              <SectionHead
                bgColor="white"
                fontWeight="400"
                textColor="black"
                description={`RD$${NIGIRI_UNIT_PRICE} por pieza | 6 piezas por RD$${NIGIRI_BUNDLE_PRICE}`}
              >
                Niguiri
              </SectionHead>
              <SectionBody className="flex-col">
                <FeaturedCard style={{ paddingTop: 0 }}>
                  <FeaturedContent>
                    <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                      <img
                        src={`${process.env.PUBLIC_URL}/img/backmenu/nigiri.png`}
                        width="80%"
                        alt="Niguiri"
                        style={{ cursor: 'default' }}
                      />
                    </div>
                    <NigiriNote style={{ marginTop: '0.75rem' }}>RD${NIGIRI_UNIT_PRICE} POR PIEZA</NigiriNote>
                    <NigiriNote>
                      {NIGIRI_BUNDLE_SIZE} PIEZAS POR RD${NIGIRI_BUNDLE_PRICE}
                    </NigiriNote>
                    <NigiriHelper>
                      Cada orden puede ser distinta. Máx {NIGIRI_BUNDLE_SIZE} piezas por orden. Usa las pestañas para alternar.
                    </NigiriHelper>
                    <NigiriTabs>
                      {nigiriOrders.map((order, idx) => (
                        <NigiriTab
                          key={order.id}
                          active={idx === activeNigiriOrder}
                          onClick={() => setActiveNigiriOrder(idx)}
                        >
                          Orden {idx + 1}
                        </NigiriTab>
                      ))}
                    </NigiriTabs>
                    <NigiriActions>
                      <NigiriActionButton onClick={addNigiriOrder}>Agregar orden</NigiriActionButton>
                      {nigiriOrders.length > 1 && (
                        <NigiriActionButton onClick={() => removeNigiriOrder(activeNigiriOrder)}>
                          Eliminar orden
                        </NigiriActionButton>
                      )}
                    </NigiriActions>
                    <NigiriGrid>
                      {activeNigiri &&
                        nigiri.map((item, idx) => (
                          <NigiriCard key={`${item.name}-${idx}`}>
                            <ItemName>{item.name}</ItemName>
                            <PriceRow>
                              <StyledCheckbox
                                type="checkbox"
                                id={`nigiri-${item.name}-${activeNigiri.id}`}
                                checked={!!activeNigiri.selected[item.name]}
                                handleChange={handleNigiriSelectChange(activeNigiriOrder, item.name)}
                              />
                              <PriceTag
                                transform="none"
                                margin="0 10px"
                                position="relative"
                                textColor="black"
                                fontWeight="400"
                                price={NIGIRI_UNIT_PRICE}
                              />
                            </PriceRow>
                            <QuantityInput
                              name={`${item.name}-qty-${activeNigiri.id}`}
                              type="number"
                              value={activeNigiri.quantities[item.name]}
                              onChange={handleNigiriQuantityChange(activeNigiriOrder, item.name)}
                              required
                            />
                          </NigiriCard>
                        ))}
                    </NigiriGrid>
                  </FeaturedContent>
                </FeaturedCard>
              </SectionBody>
            </Section>
            <Section>
              <SectionHead bgColor="white" fontWeight="400" textColor="black">
                Bastones empanizados
              </SectionHead>
              <SectionBody>
                <ComboRow>
                  {bastones.map((item, idx) => {
                    const img = bastonImages[item.name];
                    return (
                      <FeaturedCard key={`${item.name}-${idx}`} style={{ paddingTop: img ? 10 : 0 }}>
                        <FeaturedContent>
                          <PriceRow>
                            <StyledCheckbox
                              type="checkbox"
                              id={`bastones-${item.name}`}
                              checked={selected.bastones[item.name]}
                              handleChange={handleSelectChange('bastones', item.name)}
                            />
                            <PriceTag
                              transform="none"
                              margin="0 10px"
                              position="relative"
                              textColor="black"
                              fontWeight="400"
                              price={item.price}
                            />
                          </PriceRow>
                          {img && (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <BastonImage
                                src={`${process.env.PUBLIC_URL}/img/backmenu/${img}`}
                                alt={item.name}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleSelectChange('bastones', item.name)({ target: { checked: !selected.bastones[item.name] } })}
                              />
                            </div>
                          )}

                          <QuantityInput
                            name={`${item.name}-qty`}
                            type="number"
                            value={quantities.bastones[item.name]}
                            onChange={handleQuantityChange('bastones', item.name)}
                            required
                          />
                        </FeaturedContent>
                      </FeaturedCard>
                    );
                  })}
                </ComboRow>
              </SectionBody>
            </Section>

          </div>

          <MediaQuery minDeviceWidth={768}>
            {renderLimonyKingCrab()}
          </MediaQuery>

          <MediaQuery minDeviceWidth={768}>
            {renderCanasticayVerdes()}
          </MediaQuery>
        </TwoColumnGrid>

        <MediaQuery maxDeviceWidth={767}>
          <Fragment>
            {renderEstrellaSection()}
            {renderSushicakePortion()}
          </Fragment>
        </MediaQuery>

        <MediaQuery maxDeviceWidth={767}>
          {renderLimonyKingCrab()}
        </MediaQuery>

        <MediaQuery maxDeviceWidth={767}>
          {renderCanasticayVerdes()}
        </MediaQuery>

        <Footer>
          <FooterButton
            to="/ordenar"
            bg={theme.colors.primary}
            onClick={() => {
              persistSelections();
              resetMenuTwoUI();
            }}
          >
            Volver a ordenar
          </FooterButton>
          <FooterButton
            to="/ordenar/checkout"
            bg="#555"
            onClick={() => {
              persistSelections();
              resetMenuTwoUI();
            }}
          >
            Ir al checkout
          </FooterButton>
        </Footer>
      </Wrapper >
      <StickyActions>
        <ButtonLink
          to="/ordenar"
          style={{ background: 'transparent', color: '#fff' }}
          onClick={() => {
            persistSelections();
            resetMenuTwoUI();
          }}
        >
          ← Volver al menú primario
        </ButtonLink>
        <ButtonLink
          style={{ position: 'absolute', right: '0' }}
          to="/ordenar/checkout"
          onClick={() => {
            persistSelections();
            resetMenuTwoUI();
          }}
        >
          Ir al Checkout &rarr;
        </ButtonLink>
      </StickyActions>
    </Fragment >
  );
};

export default MenuTwo;
